import React from 'react';
import { Button, Modal } from 'react-bootstrap';

// ConfirmModal — the single shared confirmation dialog for consequential actions (Close, Delete,
// etc.) across the app: size="lg", backdrop="static", footer No (light) / {confirmLabel} (success).
// Parameterised by title/body/confirmLabel so every call site reuses this one component instead of
// hand-rolling its own near-identical modal. `danger` is the *trigger* elsewhere (e.g. the Delete
// dropdown item), never the confirm button here.
export default function ConfirmModal({ show, onHide, onConfirm, title, body, confirmLabel = "Yes" }) {
  const handleConfirm = () => {
    // Dispatch the action
    onConfirm();

    // Close modal
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>No</Button>
        <Button variant="success" onClick={handleConfirm}>{confirmLabel}</Button>
      </Modal.Footer>
    </Modal>
  );
}
